import * as React from "react";
import {cx} from "emotion";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSlidersH} from "@fortawesome/free-solid-svg-icons";

import "./tags-input.scss";

import {cs}   from "@Common/react/chain-services";
import {last} from "@Common/utils/collections";

export const TagsInput = (
    {
        onEnter,
        onCreateTag,
        freeText,
        tags,
        className,
        onClearAll,
        onAdvanceOpen,
        domRef,
    }
) => cs(
    // @ts-ignore
    ["handleKeyDown", (_, next) => next(
        (e) => {
            if (e.key === " " || e.key === ",") { //create tag
                e.preventDefault();
                if (freeText.value !== "") {
                    onCreateTag(freeText.value);
                    freeText.onChange("");
                }
            }
            if (e.key === "Backspace" && freeText.value === "") { // delete tag
                e.preventDefault();
                if (tags.length) {
                    last(tags).onRemove();
                }
            }
            if (e.key === "Enter") { //execute search
                e.preventDefault();
                onEnter();
            }
        }
    )],
    ["handleInputChange", (_, next) => next((e) => freeText.onChange(e.target.value))],
    ({handleKeyDown, handleInputChange}) => (
        <div
            className={cx("tags-input-4fi", className)}
            ref={domRef}
        >
            {onAdvanceOpen ? (
                <div
                    className="advanced-search-button"
                    onClick={onAdvanceOpen}
                    xd-qa-type="button"
                    xd-qa-name="advanced"
                >
                    <FontAwesomeIcon className={"sliders"} icon={faSlidersH}/>
                </div>
            ) : (
                <div
                    className="clear-button"
                    onClick={onClearAll}
                    xd-qa-type="button"
                    xd-qa-name="clear input"
                >
                    Clear
                </div>
            )}
            {tags.map((tag, i) => (
                <div 
                    className="tag"
                    key={i}
                >
                    {tag.label}
                    <i
                        className="fa fa-times x"
                        xd-qa-type="button"
                        xd-qa-name={"clear tag " + i}
                        onClick={tag.onRemove}
                    />
                </div>
            ))}
            <input
                className="input"
                value={freeText.value}
                onKeyDown={handleKeyDown}
                onChange={handleInputChange}
                xd-qa-type="textbox"
                xd-qa-name="Search"
                placeholder={tags.length ? "" : "Search by Order Name or ID"}
            />
        </div>
    )
);
